import _ from 'lodash';
import moment from 'moment';

export const loadEventWidgets = eventId => {
    return fetch(`https://ss2.si-ab.com/events-v2/?eventId=${eventId}`)
        .then(response => response.json())
        .then(response => _.get(response, 'events[0]', null))
        .then(event => {
            return Promise.all([
                event,
                fetch(`https://ss2.si-ab.com/tournaments/${event.tournamentTemplateId}`),
                // lieneup
                // streaks
                // h2h
                // last matches
            ]).then(([event, tournament]) => {
                const data = {
                    event,
                    tournament,
                };
                return {
                    data,
                    widgets: prepareEventWidgets(data),
                };
            });
        });
};

export const prepareEventWidgets = data => {
    const { event } = data;
    return [
        // TABLE
        ...announments(event, 'ANNOUNCMENTS'),
        ...leagueTable(event, 'STANDINGS'),
    ];
};

export const announments = (event, category) => {
    return ['MatchAnnouncement'].map(wid => ({
        id: wid,
        props: {
            eventId: event.eventId,
        },
        spec: {
            social: true,
            widgetGroup: event.eventId,
        },
        category: [category],
        key: `${wid}-${event.eventId}`,
    }));
};

export const leagueTable = event => {
    return [
        {
            id: 'TournamentTableSMWidget',
            props: {
                tournamentId: event.tournamentTemplateId,
                seasonId: event.tournamentId,
                teamId: event.homeId,
                team1Id: event.homeId,
                team2Id: event.awayId,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TournamentTableSMWidget',
            },
            category: ['Table'],
            key: `tt-table`,
        },
        {
            id: 'LeagueTrackerSMWidget',
            props: {
                tournamentId: event.tournamentTemplateId,
                seasonId: event.tournamentId,
                teamId: event.homeId,
                team1Id: event.homeId,
                team2Id: event.awayId,
            },
            spec: {
                social: true,
                widgetGroup: 'LeagueTrackerSMWidget',
            },
            category: ['Table'],
            key: `tt`,
        },
    ];
};

export const topPlayers = data => {
    const { tournament, team } = data;

    return [
        {
            id: 'TeamSeasonTopscorersX3V1',
            props: {
                tournamentId: tournament.id,
                teamId: team.id,
                showTShirt: true,
                showTitle: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TeamSeasonTopscorersX3V1',
            },
            category: ['Top players'],
            key: `tt-table`,
        },
        {
            id: 'TeamSeasonTopscorersX3V2',
            props: {
                tournamentId: tournament.id,
                teamId: team.id,
                showTShirt: true,
                showTitle: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TeamSeasonTopscorersX3V2',
            },
            category: ['Top players'],
            key: `tt-table-x2`,
        },
    ];
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/loaders/event.js
 **/